import SoundManager from '../utils/SoundManager'
import ClickTrack from '../utils/click-track'
import debounce from 'debounce';

export class Sound {
    constructor(el, isScrollTrigger = false) {
        console.log('Loaded Sound')
        this.el = el
        this.scrollTrigger = isScrollTrigger
        this.audiosToUnlock = document.querySelectorAll('audio.toUnlock')

        this.button = el.querySelector('.sound_cta__button')

        this.activeClass = 'sound_cta__button--active'
        this.triggers = document.querySelectorAll('.audio_trigger')
        this.triggerObservers = []

        this._soundManager = new SoundManager()
        this._soundManager.addControl(this)
        this._alreadyPlayedSounds = []
        this._currentElementInView = null

        this._setupEvents()
    }

    _setupEvents() {
        this.button.addEventListener('click', () => {
            this._toggleSound()
        })

        if (this.scrollTrigger) {
            /*document.addEventListener('scroll', function(e) {
                let id = this._currentElementInView
                console.log('scroll in id is', id)
                if (id) {
                    console.log('trying to play', id)
                }
            }.bind(this))*/
            this.triggers.forEach((el) => {
                console.log(`setting up element ${el.dataset.target}`)
                let options = {
                    threshold: 0,
                    rootMargin: '0% 0%'
                }
                let observer = new IntersectionObserver((entries, observer) => {
                    // console.log('h')
                    this._manageTrigger(el, entries, observer)
                }, options)
                observer.observe(el)
                this.triggerObservers.push(observer)
            })
        }
    }

    _manageTrigger(el, entries, observer) {
        let that = this
        entries.forEach(entry => {
            let id = el.dataset.target
            if (entry.isIntersecting) {
                console.log(`enter element ${id}`)
                this._currentElementInView = id

                if (!this._alreadyPlayedSounds.includes(id)) {
                    if (this._soundManager.playing) {
                        this._soundManager.playSound(id)
                        this._alreadyPlayedSounds.push(id)
                    }
                } else {
                    console.log('already played', id)
                }
            } else {
                console.log(`exit element ${id}`)
                this._currentElementInView = null
            }
        })
    }

    _toggleSound() {
        if (this._soundManager.playing) {
            ClickTrack.track('cta_click', 'cta click', 'sound off', 'sound off')
            this.button.classList.remove(this.activeClass)
            this._soundManager.stopSound()
        } else {
            for(let audio of this.audiosToUnlock) {
                console.log('unlocking audio ', audio)
                audio.play()
                audio.pause()
                audio.currentTime = 0
            }
            ClickTrack.track('cta_click', 'cta click', 'sound on', 'sound on')
            this.button.classList.add(this.activeClass)
            this._soundManager.playSound('main')
        }
    }

    setStatus(what) {
        console.log('received status update', what)
        if (!what) {
            this.button.classList.remove(this.activeClass)
        } else {
            this.button.classList.add(this.activeClass)
        }
    }

    _isMobile() {
        return window.matchMedia('(max-width: 1023px)').matches
    }

    insertVideoSource(isMobile) {

    }


    onResize() {

        // this._setupEvents() not needed
    }

}
